import { createGlobalStyle } from 'styled-components';

import { Brand } from '@src/types/content/brand';

const BrandTheme = createGlobalStyle<{ brand: Brand }>`
  :root {
    --color-primary: ${({ brand }) => brand.primaryColor?.hex};
    --color-primary-alpha: rgba(0, 0, 0, .5);
    --color-secondary: var(--color-whitelabel-secondary);
  }
`;
export default BrandTheme;
